module.exports = ".accor-menu-green {\n    background: #2d5a3d !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/utility/survey-history/survey-history.component.css
// module id = ./src/app/modules/housekeeping/utility/survey-history/survey-history.component.css
// module chunks = main